import { render, staticRenderFns } from "./modalAnexo.vue?vue&type=template&id=817ccc40&"
import script from "./modalAnexo.vue?vue&type=script&lang=js&"
export * from "./modalAnexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports